import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function FooterLegal() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const closeModal = () => setActiveModal(null);
  return <footer className="py-8 border-t border-[#111] bg-[#050505] text-center" data-id="element-158">
      <div className="flex flex-col items-center gap-4" data-id="element-159">
        <p className="text-[#555] text-xs" data-id="element-160">
          © 2025 Trading en Paz. Todos los derechos reservados.
        </p>
        <div className="flex gap-6 text-xs text-[#8a8578]" data-id="element-161">
          <button onClick={() => setActiveModal('privacy')} className="hover:text-[#d4af37] transition-colors underline decoration-[#333] underline-offset-4" data-id="element-162">
            Política de Privacidad
          </button>
          <button onClick={() => setActiveModal('terms')} className="hover:text-[#d4af37] transition-colors underline decoration-[#333] underline-offset-4" data-id="element-163">
            Términos y Condiciones
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-164">
        {activeModal && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-id="element-165">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={closeModal} className="absolute inset-0 bg-black/80 backdrop-blur-sm" data-id="element-166" />

            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="relative w-full max-w-2xl max-h-[80vh] overflow-y-auto bg-[#0a0a0a] border border-[#222] rounded-xl shadow-2xl shadow-black" data-id="element-167">
              <button onClick={closeModal} className="absolute top-4 right-4 p-2 text-[#8a8578] hover:text-[#f5f0e8] transition-colors" data-id="element-168">
                <X size={20} data-id="element-169" />
              </button>

              <div className="p-8 text-left" data-id="element-170">
                {activeModal === 'privacy' && <div className="space-y-6 text-[#8a8578] text-sm leading-relaxed" data-id="element-171">
                    <h2 className="text-2xl font-serif text-[#f5f0e8] mb-6" data-id="element-172">
                      Política de Privacidad
                    </h2>

                    <section data-id="element-173">
                      <h3 className="text-[#f5f0e8] font-bold mb-2" data-id="element-174">
                        1. Recolección de Datos
                      </h3>
                      <p data-id="element-175">
                        Recolectamos información personal limitada (como su
                        dirección de correo electrónico) necesaria para procesar
                        su compra y entregar el producto digital. No almacenamos
                        información de tarjetas de crédito ni datos bancarios;
                        estos son procesados de forma segura por Hotmart.
                      </p>
                    </section>

                    <section data-id="element-176">
                      <h3 className="text-[#f5f0e8] font-bold mb-2" data-id="element-177">
                        2. Uso de la Información
                      </h3>
                      <p data-id="element-178">
                        Su información se utiliza exclusivamente para: entregar
                        el producto adquirido, enviar actualizaciones
                        relacionadas con el producto, y brindar soporte al
                        cliente. No vendemos ni compartimos sus datos con
                        terceros con fines comerciales.
                      </p>
                    </section>

                    <section data-id="element-179">
                      <h3 className="text-[#f5f0e8] font-bold mb-2" data-id="element-180">
                        3. Cookies
                      </h3>
                      <p data-id="element-181">
                        Utilizamos cookies esenciales para mejorar su
                        experiencia de navegación y analizar el tráfico del
                        sitio de forma anónima. Puede desactivar las cookies en
                        la configuración de su navegador.
                      </p>
                    </section>

                    <section data-id="element-182">
                      <h3 className="text-[#f5f0e8] font-bold mb-2" data-id="element-183">
                        4. Derechos del Usuario
                      </h3>
                      <p data-id="element-184">
                        Usted tiene derecho a solicitar el acceso, corrección o
                        eliminación de sus datos personales en cualquier
                        momento. Para ejercer estos derechos, contáctenos.
                      </p>
                    </section>

                    <section data-id="element-185">
                      <h3 className="text-[#f5f0e8] font-bold mb-2" data-id="element-186">
                        5. Contacto
                      </h3>
                      <p data-id="element-187">
                        Para cualquier duda sobre privacidad, puede escribirnos
                        a: privacidad@tradingenpaz.com
                      </p>
                    </section>
                  </div>}

                {activeModal === 'terms' && <div className="space-y-6 text-[#8a8578] text-sm leading-relaxed" data-id="element-188">
                    <h2 className="text-2xl font-serif text-[#f5f0e8] mb-6" data-id="element-189">
                      Términos y Condiciones
                    </h2>

                    <section data-id="element-190">
                      <h3 className="text-[#f5f0e8] font-bold mb-2" data-id="element-191">
                        1. Producto Digital
                      </h3>
                      <p data-id="element-192">
                        Al adquirir "Trading en Paz", usted obtiene una licencia
                        personal, no exclusiva e intransferible para usar el
                        material digital. Debido a la naturaleza del producto
                        (descarga inmediata), no se ofrecen reembolsos una vez
                        entregado el acceso, salvo excepciones legales
                        aplicables.
                      </p>
                    </section>

                    <section data-id="element-193">
                      <h3 className="text-[#f5f0e8] font-bold mb-2" data-id="element-194">
                        2. Propiedad Intelectual
                      </h3>
                      <p data-id="element-195">
                        Todo el contenido, incluyendo textos, gráficos,
                        logotipos y material descargable, es propiedad exclusiva
                        de Trading en Paz. Está prohibida su reproducción,
                        distribución o venta sin autorización expresa.
                      </p>
                    </section>

                    <section data-id="element-196">
                      <h3 className="text-[#f5f0e8] font-bold mb-2" data-id="element-197">
                        3. Descargo de Responsabilidad
                      </h3>
                      <p data-id="element-198">
                        Este producto es material educativo sobre psicología del
                        trading. No constituye asesoramiento financiero ni de
                        inversión. Los resultados en el trading varían y
                        conllevan riesgos significativos. No garantizamos
                        ganancias ni resultados específicos.
                      </p>
                    </section>

                    <section data-id="element-199">
                      <h3 className="text-[#f5f0e8] font-bold mb-2" data-id="element-200">
                        4. Aceptación
                      </h3>
                      <p data-id="element-201">
                        Al realizar la compra, usted acepta estos términos y
                        condiciones en su totalidad.
                      </p>
                    </section>
                  </div>}
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>
    </footer>;
}